var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoicedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DDF9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 8.6875V23.3125H19.375V22.1875H11.5V9.8125H17.125V13.1875H20.5V14.3125H21.625V12.4L21.4563 12.2313L18.0813 8.85625L17.9125 8.6875H10.375ZM18.25 10.6L19.7125 12.0625H18.25V10.6ZM22.1875 15.4375V16.5625C21.2312 16.7312 20.5 17.5188 20.5 18.5312C20.5 19.6562 21.3438 20.5 22.4688 20.5H23.0312C23.4812 20.5 23.875 20.8938 23.875 21.3438C23.875 21.7937 23.4812 22.1875 23.0312 22.1875H21.0625V23.3125H22.1875V24.4375H23.3125V23.3125C24.2688 23.1438 25 22.3562 25 21.3438C25 20.2188 24.1562 19.375 23.0312 19.375H22.4688C22.0188 19.375 21.625 18.9812 21.625 18.5312C21.625 18.0813 22.0188 17.6875 22.4688 17.6875H24.4375V16.5625H23.3125V15.4375H22.1875Z",
    fill: "#48A14D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 18L15.333 20L18.6663 16",
    stroke: "#48A14D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicedIcon);
export default __webpack_public_path__ + "static/media/invoicedIcon.6b45bae355766a49a58161c91cb1db7a.svg";
export { ForwardRef as ReactComponent };